export const formatNumber = (value) =>
    new Intl.NumberFormat('ru-RU').format(value);
